import React, { useEffect, useRef, useState } from "react";
import styles from "./workWithUs.module.scss";
import careerImg from "../../assests/careersPageImg.png";

const WorkWithUs = () => {
  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
        console.log(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (MyRef.current) {
      observer.observe(MyRef.current);
    }

    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, [MyRef, visible]);

  return (
    <div className={styles.container} ref={MyRef}>
      <div className={styles.wrapper}>
        <div className={visible ? styles.headEvent : styles.head} ref={MyRef}>
          Why work with Us?
        </div>
        <div className={styles.careerTop}>
          <div
            className={
              visible ? styles.careerTopLeftEvent : styles.careerTopLeft
            }
          >
            <img src={careerImg} alt="" />
          </div>
          <div
            className={
              visible ? styles.careerTopRightEvent : styles.careerTopRight
            }
          >
            <div className={styles.heading}>
              KRIHA MEGAM IS NEWS ON OUR OFFICIAL BLOG
            </div>
            <div className={styles.description}>
              Creating and sticking to a budget is essential for achieving
              financial stability and reaching your financial goals. Whether
              you're saving for a big purchase, paying off debt, or just trying
              to manage your day-to-day expenses, a well-planned budget can make
              all the difference. In this blog post, we'll walk you through top
              tips for effective financial planning and how you can use megam to
              streamline the process.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkWithUs;
